
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getGlobalState } from '@states/ProfileState';
import Image from '@components/Image';
import Button from '@/src/components/Button';
import AnchorLink from '@components/AnchorLink';
import InfoModal from '@components/InfoModal';
import DownloadPortrait from '@components/DownloadPortrait';
import { useWindowWidth } from '@hooks/windowHooks';
import { breakpoints } from '@hooks/useBreakpoints';
import { trackEvent } from '@utils/analytics';
import { PORTRAIT_MAKER } from '@constants/routes';
import { SHOW_SHARE_YOUR_PORTRAIT } from '@constants/avatar-maker';
import ShareYourPortrait from '../ShareYourPortrait';
import { ReactComponent as DownloadIcon } from '../../../../../images/icons/download-icon.svg';
import { ReactComponent as EditIcon } from '../../../../../images/icons/edit-icon.svg';
import s from './UserPortrait.module.scss';
const propTypes = {
    avatarCompleted: PropTypes.bool.isRequired,
    userHouse: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired
};
const UserPortrait = ({ avatarCompleted, userHouse, pageName }) => {
    const avatarImage = getGlobalState('userAvatarImage');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [invalidAvatarImage, setInvalidAvatarImage] = useState(false);
    const [showSharePortraitModal, setShowSharePortraitModal] = useState(localStorage.getItem(SHOW_SHARE_YOUR_PORTRAIT) || false);
    localStorage.removeItem(SHOW_SHARE_YOUR_PORTRAIT);
    const width = useWindowWidth();
    const isMobile = width < breakpoints.xm;
    const toggleMobileMenuOpen = () => {
        if (isMobile || mobileMenuOpen)
            setMobileMenuOpen(!mobileMenuOpen);
    };
    return (<div className={s.container}>
      {avatarCompleted && avatarImage && !invalidAvatarImage && (<div className={s.completedContainer}>
          <div className={s.avatarImage}>
            <InfoModal isOpen={mobileMenuOpen} toggleModal={toggleMobileMenuOpen} className={s.avatarModal} secondaryCloseBtn closeBtnColor="#FFF" autoSize>
              <div className={[s.modalContent, s[userHouse]].join(' ')}>
                <div className={s.yourAvatarText}>
                  Your&nbsp;
                  <div className={s.largerText}>Portrait</div>
                </div>
                <DownloadPortrait>
                  <Button type="secondary" label="Download" title="Download" data-testid="mobileSaveBtn" contentLeft={<DownloadIcon />} onClick={() => {
                toggleMobileMenuOpen();
            }}/>
                </DownloadPortrait>
                <AnchorLink href={PORTRAIT_MAKER} title="Edit" data-testid="mobileEditBtn" onClick={() => {
                trackEvent('CTA Clicked', {
                    cta_text: 'Edit',
                    label: 'Edit',
                    location: pageName
                });
            }}>
                  <Button type="secondary" label="Edit" contentLeft={<EditIcon />}/>
                </AnchorLink>
              </div>
            </InfoModal>
            <button className={s.imageButton} type="button" title="Portrait Menu" onClick={toggleMobileMenuOpen}>
              <Image imageSet={[{ src: avatarImage }]} contain center alt="Portrait image" onError={() => {
                setInvalidAvatarImage(true);
            }}/>
            </button>
            <div className={s.avatarButtons}>
              <DownloadPortrait>
                <Button type="secondary" label="Download" data-testid="desktopSaveBtn" className={s.saveBtn} contentLeft={<DownloadIcon />}/>
              </DownloadPortrait>
              <AnchorLink href={PORTRAIT_MAKER} title="Edit" data-testid="desktopEditBtn" onClick={() => {
                trackEvent('CTA Clicked', {
                    cta_text: 'Edit',
                    label: 'Edit',
                    location: pageName
                });
            }}>
                <Button label="Edit" type="secondary" contentLeft={<EditIcon />} className={s.editBtn}/>
              </AnchorLink>
            </div>
          </div>
        </div>)}
      {(!avatarCompleted || !avatarImage || invalidAvatarImage) && (<div className={[s.notCompletedContainer, s[userHouse]].join(' ')}>
          <div className={[s.header, s[userHouse]].join(' ')}>
            Create your
            <br />
            Portrait
          </div>
          <AnchorLink className={s.startLink} href={PORTRAIT_MAKER} title="Portrait Maker" onClick={() => {
                trackEvent('CTA Clicked', {
                    cta_text: 'Start',
                    label: 'Avatar start',
                    location: pageName
                });
            }}>
            <Button label="Start" className={[s.startBtn, s[userHouse]].join(' ')}/>
          </AnchorLink>
        </div>)}
      {showSharePortraitModal && (<ShareYourPortrait onCloseModal={() => {
                setShowSharePortraitModal(false);
            }}/>)}
    </div>);
};
UserPortrait.propTypes = propTypes;
export default UserPortrait;

    async function __Next_Translate__getStaticProps__195ca0f1655__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/UserPanel/UserPortrait/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0f1655__ as getStaticProps }
  